interface DateTimeFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string;
}

export default function DateTimeField({
  label,
  value,
  onChange,
  required = false,
  error,
}: DateTimeFieldProps) {
  // Convert datetime-local format for input
  const formatForInput = (val: string) => {
    if (!val) return '';
    // If it's already in datetime-local format, return as is
    if (val.includes('T')) return val;
    // If it's just a date, add time
    if (val.match(/^\d{4}-\d{2}-\d{2}$/)) return `${val}T00:00`;
    return val;
  };

  return (
    <div>
      <label className="block text-xs text-gray-400 mb-1.5">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <input
        type="datetime-local"
        value={formatForInput(value)}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full bg-[#1a1f3a] border rounded-lg px-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-orange-500/50 ${
          error ? 'border-red-500/50' : 'border-[#2d1b3d]'
        }`}
      />
      {error && <div className="text-xs text-red-400 mt-1">{error}</div>}
    </div>
  );
}



